/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React from "react";
import tw, { css, theme } from "twin.macro";
import { useMediaQuery } from "~hooks";

import * as T from "~components/styles/Typography.jsx";
import * as Icons from "~components/svg/Icons.jsx";
import Image from "~components/Image.jsx";
import SwiperCarousel from "~components/SwiperCarousel.jsx";

import blankImage from "~assets/images/image-full.jpg";

const TeamGridSection = ({ data }) => {
  const { members, placeholder } = data;
  const { isDesktop } = useMediaQuery();
  //

  return (
    <section css={[tw`relative flex flex-wrap`]}>
      {isDesktop ? (
        <>
          {members.map((member) => (
            <article
              key={member._key}
              css={[
                css`
                  background-color: ${member.backgroundColor?.hex || `white`};
                  color: ${member.textColor?.hex || `black`};
                `,
                tw`w-full md:w-1/3 relative block`
              ]}
            >
              <div css={[tw`w-full h-[36vw] relative block overflow-hidden`]}>
                {member.image ? (
                  <Image image={member.image} _css={[tw`w-full h-full`]} />
                ) : (
                  <img
                    src={blankImage}
                    css={tw`w-full h-full object-cover`}
                    alt="blank"
                  />
                )}
              </div>

              <div css={[tw`w-full relative pt-12 px-12 pb-16`]}>
                <T.Head _css={[tw`mb-4`]} font="4" level="2">
                  {member.name}
                </T.Head>

                <T.Body _css={[tw`mb-8`]}>{member.title}</T.Body>

                <T.Body font="2" _css={[tw`mb-2`]}>
                  Favourite Sandwich:
                </T.Body>
                <T.Body font="2">{member.favourite}</T.Body>
              </div>
            </article>
          ))}

          <article
            css={[
              tw`relative block`,
              css`
                color: ${placeholder?.textColor?.hex || `white`};
                background-color: ${placeholder?.backgroundColor?.hex ||
                `black`};
              `,
              members.length % 3 === 0
                ? tw`w-full`
                : members.length % 3 === 1
                ? tw`w-2/3`
                : tw`w-1/3`
            ]}
          >
            <div css={[tw`w-full h-[36vw] relative block overflow-hidden`]}>
              <Image image={placeholder?.image} _css={[tw`w-full h-full`]} />
            </div>

            <div
              css={[
                tw`relative pt-12 px-12 pb-16`,
                members.length % 3 === 0 || members.length % 3 === 1
                  ? tw`w-2/3`
                  : tw`w-full`
              ]}
            >
              <T.Head _css={[tw`mb-4`]} font="4" level="2">
                {placeholder?.header}
              </T.Head>
            </div>
          </article>
        </>
      ) : (
        <>
          <SwiperCarousel
            nav={({ current, next, prev }) => (
              <div
                css={[
                  tw`w-full relative bottom-0 right-0 left-0 z-10 flex items-center justify-between pt-4 pb-4 px-4`
                ]}
              >
                <button
                  tw="relative block w-6 flex items-center justify-center"
                  type="button"
                  onClick={prev}
                >
                  <Icons.Arrow
                    _css={[
                      tw`w-4 transform rotate-180`,
                      css`
                        & > * {
                          fill: ${theme`colors.red-dark`};
                        }
                      `
                    ]}
                  />
                </button>

                <T.Caption _css={[tw`text-red-dark`]}>{`${current + 1}/ ${
                  members.length
                }`}</T.Caption>

                <button
                  tw="relative block w-6 flex items-center justify-center"
                  type="button"
                  onClick={next}
                >
                  <Icons.Arrow
                    color="black"
                    _css={[
                      tw`w-4`,
                      css`
                        & > * {
                          fill: ${theme`colors.red-dark`};
                        }
                      `
                    ]}
                  />
                </button>
              </div>
            )}
            slides={members.map((member) => {
              const key = `${member._key}-mobile`;
              return (
                <article
                  key={key}
                  css={[
                    css`
                      background-color: ${member.backgroundColor?.hex ||
                      `white`};
                      color: ${member.textColor?.hex || `black`};
                    `,
                    tw`w-full h-full relative block`
                  ]}
                >
                  <div
                    css={[tw`w-full h-[60vw] relative block overflow-hidden`]}
                  >
                    {member.image ? (
                      <Image image={member.image} _css={[tw`h-full`]} />
                    ) : (
                      <img
                        src={blankImage}
                        css={tw`w-full h-full object-cover`}
                        alt="blank"
                      />
                    )}
                  </div>

                  <div css={[tw`w-full relative pt-12 px-6 pb-16`]}>
                    <T.Head _css={[tw`mb-4`]} font="4" level="2">
                      {member.name}
                    </T.Head>

                    <T.Body _css={[tw`mb-8`]}>{member.title}</T.Body>

                    <T.Body font="2" _css={[tw`mb-2`]}>
                      Favourite Sandwich:
                    </T.Body>
                    <T.Body font="2">{member.favourite}</T.Body>
                  </div>
                </article>
              );
            })}
          />
        </>
      )}
    </section>
  );
};

export default TeamGridSection;
